import {create} from "zustand/react";
import {User} from "../api/types/User";
import {ApiService} from "../api/ApiService";
import {LoginResponse} from "../api/types/LoginResponse";
import {ApiFailure, ApiSuccess} from "../api/types/ApiResponse";

type AUTH_CHECK_STATUS = "CHECKING" | "AUTHENTICATED" | "NOT_AUTHENTICATED";

export interface UserState {
    user?: User,
    status: AUTH_CHECK_STATUS;
    setStatus: (status: AUTH_CHECK_STATUS) => void;
}

export interface UserStore extends UserState {
    fetchUser: () => Promise<ApiSuccess<User> | ApiFailure<null>>,
    login: (loginResponse?: LoginResponse | null) => Promise<ApiSuccess<User> | ApiFailure<null>>,
    logout: () => void,
}

export const useUserStore = create<UserStore>()((set, get) => ({
    user: undefined,
    status: "CHECKING",
    setStatus: (status: AUTH_CHECK_STATUS) => set(() => ({status})),
    fetchUser: async () => {
        const getUserResponse = await ApiService.GetUser();
        if (getUserResponse.success) {
            set(() => ({user: getUserResponse.data!}));
        }
        return getUserResponse;
    },
    login: async (loginResponse) => {
        if (loginResponse) {
            localStorage.setItem("token", loginResponse.accessToken);
            localStorage.setItem("refreshToken", loginResponse.refreshToken);
        }
        get().setStatus("CHECKING");
        const response = await get().fetchUser();
        if (response.success) {
            get().setStatus("AUTHENTICATED");
        } else {
            get().setStatus("NOT_AUTHENTICATED");
        }
        return response;
    },
    logout: () => {
        localStorage.removeItem("token");
        localStorage.removeItem("lastApplicant");
        localStorage.removeItem("refreshToken");
        set(() => ({user: undefined, status: "NOT_AUTHENTICATED"}));
    }
}));